import api from '../lib/api';
import { toArray } from '../lib/utils';
import type { Assistant } from '../types/api';
import type { KnowledgeBase, KnowledgeBaseFilters, KnowledgeBaseResponse } from '../types/knowledge';

class KnowledgeService {
  async getEntries(filters?: KnowledgeBaseFilters, page: number = 1, limit: number = 20): Promise<KnowledgeBaseResponse> {
    const response = await api.get('/knowledge-base', {
      params: {
        ...filters,
        page,
        limit,
      },
    });
    return response.data;
  }

  async createEntry(data: Partial<KnowledgeBase>): Promise<KnowledgeBase> {
    const response = await api.post('/knowledge-base', data);
    return response.data.data;
  }

  async updateEntry(id: number, data: Partial<KnowledgeBase>): Promise<KnowledgeBase> {
    const response = await api.put(`/knowledge-base/${id}`, data);
    return response.data.data;
  }

  async deleteEntry(id: number): Promise<void> {
    await api.delete(`/knowledge-base/${id}`);
  }

  async getAssistants(): Promise<Assistant[]> {
    const response = await api.get('/assistants');
    return toArray(response.data);
  }
}

export default new KnowledgeService();
